import React, { useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    Level,
    LevelItem,
    Divider,
    Grid, GridItem 
} from "@patternfly/react-core";

import { getMediaUrl } from "../../../utils/media";
import { getMonths } from "shared/utils/monthsUtils";
import { SheetTypesGrid } from "./grids/SheetTypesGrid";

import { DevSolutionsCell } from "../columns/DevSolutionsCell";
import { SheetNameCell } from "../columns/SheetNameCell";

import { ShareCell } from "../columns/ShareCell";

import { useBranch } from "../../../hooks/useBranch";

import fallbackImg from 'shared/assets/images/webp/fallback-img-pl-black.webp';

export const SheetDetails = ({ row, props, context, Icons, setSheets, groupFilter, viewMode, isSelected }) => {
    const branch = useBranch();
    const hasFiles =
        Boolean(row?.answer_key_url?.length) ||
        Boolean(row?.attachment_url?.length);

    const groupsCompleted = React.useMemo(() => {
        const rawGroups = row?.groups_completed || {};
        // filtrujemy stare grupy
        return Object.fromEntries(
            Object.entries(rawGroups).filter(
            ([_, item]) => item && !item.group_symbol?.toUpperCase().startsWith("ABS")
            )
        );
        }, [row?.groups_completed]);

    const sheetName = row?.name || "Brak nazwy";
    
    const miniature = row?.raw?.sheet_miniature;
    const sheetUrl = row?.raw?.sheet_url;
    
    const miniatureUrl = miniature
    ? miniature.includes("/miniature/") // jeśli nowa struktura
        ? `${props.state.api_url}${miniature}`  // nowy URL
        : `${props.state.api_url}/${props.state.django_media_dir}/${miniature}` // stara struktura
    : null;

    const [imgSrc, setImgSrc] = useState(
        miniature ? miniatureUrl : fallbackImg
    );

    const [loaded, setLoaded] = useState(false);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);

    const handleDownload = () => {
        if (!sheetUrl) return;
        getMediaUrl(
            `${props.state.api_url}/${props.state.django_media_dir}/${sheetUrl}`,
            sheetName
        );
    };

    const hasSolutions =
        (row.raw.html_css_url && row.raw.html_css_url !== "") ||
        (row.raw.angular_url && row.raw.angular_url !== "None") ||
        (row.raw.react_url && row.raw.react_url !== "None") ||
        (row.raw.solution_url && row.raw.solution_url !== "None") ||
        (row.raw.solutions.length > 0);

    return (
        <>
        <Grid 
          hasGutter
          style={{
              fontSize: "13px",
            //   color: "#cfcfcf",
              lineHeight: "1.6"
          }}
        >
          <GridItem span={2}>
            {/* {row?.raw?.qualification_type === "dev" && ( */}
            {miniature && (
              <>
              {/* IMAGE CONTAINER */}
              <div
                  className="ultra-card-image"
                  onClick={(e) => {
                      e.stopPropagation();
                      setIsPreviewOpen(true);
                  }}
                  style={{
                      position: "relative",
                      height: "110px",
                      width: "150px",
                      borderRadius: "14px",
                      overflow: "hidden",
                      cursor: "zoom-in",
                  }}
              >

                  {/* LOADING GLASS OVERLAY */}
                  {/* {!loaded && (
                      <div
                          style={{
                              position: "absolute",
                              inset: 0,
                              backdropFilter: "blur(12px)",
                              background:
                                  "linear-gradient(90deg,#2a2a2a,#3a3a3a,#2a2a2a)",
                              backgroundSize: "200% 100%",
                              animation: "shimmer 1.5s infinite"
                          }}
                      />
                  )} */}

                  {/* IMAGE */}
                  <img
                      src={imgSrc}
                      alt={sheetName}
                      loading="lazy"
                      onLoad={() => setLoaded(true)}
                      onError={() => setImgSrc(fallbackImg)}
                      style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          transition: "0.6s ease",
                          filter: loaded
                              ? "grayscale(20%) brightness(105%)"
                              : "grayscale(90%)"
                      }}
                  />

                  {/* ENTERPRISE FLOATING ACTION BAR */}
                  {/* <div
                      className="ultra-actions"
                      style={{
                          position: "absolute",
                          bottom: "12px",
                          right: "12px",
                          display: "flex",
                          gap: "8px",
                          opacity: 0,
                          transform: "translateY(10px)",
                          transition: "0.35s ease"
                      }}
                  >
                      <Button
                          variant="secondary"
                          icon={<ExternalLinkAltIcon />}
                          onClick={(e) => {
                              e.stopPropagation();
                              setIsPreviewOpen(true);
                          }}
                      />

                      <Button
                          variant="primary"
                          icon={<DownloadIcon />}
                          onClick={(e) => {
                              e.stopPropagation();
                              handleDownload();
                          }}
                      />
                  </div> */}
              </div>
              </>
            )}
          </GridItem>
          <GridItem span={3}>
            {/* META INFO PANEL */}
            <b>Sesja:</b> {getMonths(row.exam_month)}
            <Divider />
            {/* <b>Nr:</b> {row.raw?.task_number?.toString().padStart(2, "0")} */}
            
            <Level>
              <LevelItem><b>Nr:</b> {row.raw?.task_number?.toString().padStart(2, "0")}</LevelItem>
            </Level>
            <Divider />
            <br />
            {hasSolutions && (
              <>
              <Level>
                  <LevelItem><b>Rozwiązania:</b></LevelItem>
                  <LevelItem>
                      <DevSolutionsCell row={row} props={props} context={context} />
                  </LevelItem>
              </Level>
              
              {/* {context.state.isAuthUser && context.state.userProfile.is_superuser && ( */}
                <Level>
                    <LevelItem><b>Udostępnij rozwiązania:</b></LevelItem>
                    <LevelItem>
                        <ShareCell row={row} props={props} setSheets={setSheets} branch={branch} context={context} />
                    </LevelItem>
                </Level>
              {/* )} */}
              </>
            )}
          </GridItem>
          {/* Typy Zadań */}
          <GridItem span={7} rowSpan={2}>
            {row?.raw?.sheet_types?.length > 0 &&
              <SheetTypesGrid row={row} groupFilter={groupFilter} />
            }
          </GridItem>
          {/* Inne dane */}
          <GridItem span={5}>
            
          </GridItem>
        </Grid>
        {/* FULLSCREEN PREVIEW */}
        <Modal
            isOpen={isPreviewOpen}
            onClose={() => setIsPreviewOpen(false)}
            variant="large"
            onEscapePress={(event) => {
                event.stopPropagation();
                setIsPreviewOpen(false);
            }}
        >
            <ModalHeader
                // onClick={() => setIsPreviewOpen(false)}
                title={
                    <>
                    Id: {row.id}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {getMonths(row.exam_month)} {row.year} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Nr: {row.raw?.task_number?.toString().padStart(2, "0")} 
                    </>
                }
                labelId="basic-modal-title" 
                // description={`[ ${row.year} ${row.exam_month} Nr: ${row.raw.task_number} ]`}
            />
            <ModalBody
                onClick={() => setIsPreviewOpen(false)}
                style={{
                    textAlign: "center",
                    // background: "#0f0f0f"
                }}>
                <img
                    src={imgSrc}
                    alt={sheetName}
                    style={{
                        maxWidth: "100%",
                        maxHeight: "85vh",
                        borderRadius: "16px",
                        boxShadow: "0 40px 120px rgba(0,0,0,.8)"
                    }}
                />
                <Level
                    style={{
                        // paddingTop: "10px",
                        // paddingBottom: "5px",
                        fontSize: "13px",
                        // color: "#cfcfcf",
                        lineHeight: "1.6"
                    }}
                >
                    <LevelItem>
                        <SheetNameCell row={row} props={props} context={context} withMiniature={false} withPopover={false} />
                    </LevelItem>
                </Level>
            </ModalBody>
        </Modal>
        <style>
            {`
            @keyframes shimmer {
                0% { background-position: -200% 0 }
                100% { background-position: 200% 0 }
            }
            .ultra-card-image img {
                will-change: transform, filter;
            }
            .ultra-card-image:hover img {
                transform: scale(1.02);
                filter: grayscale(0%) brightness(110%);
            }
            .ultra-card-image:hover div:nth-child(3) {
                opacity: 1;
            }
            `}
        </style>
        </>
    );
};

